/*window.user =*/
$(document).ready(function () {
    blurPreviewDesign();
});
$(window).scroll(function () {
    if (!user) {
        if (location.search.includes('version')) {
            hideBlurContent();
            $('#blurModal').hide();
        } else {
            $('.blurEffectSchool>*').css('filter', 'blur(.825rem)');
            blurPreviewDesign();
        }
    } else $('#blurModal').hide();
});

$(document).scrollTop($(document).scrollTop() - 1);


window.hideBlurContent = () => {
    $('.blurEffectSchool>*').css('filter', 'blur(0px)');
}


window.blurPreviewDesign = () => {
    if (!user) {
        $('.blurEffectSchool>*').css('filter', 'blur(.825rem)');
    } else {
        hideBlurContent();
        $('#blurModal').hide();
    }
    blurDesignModal();
}

window.blurDesignModal = () => {
    if (!user) {
        var scrollTop = $(window).scrollTop();
        var blurEffectSchoolTop = $('.blurEffectSchool').offset().top;

        if (scrollTop >= blurEffectSchoolTop && scrollTop <= blurEffectSchoolTop + $('.blurEffectSchool').height()) {
            // The .blurEffectSchool div is in view, show the #blurModal
            $('#blurModal').show();
        } else {
            // The .blurEffectSchool div is not in view, hide the #blurModal
            $('#blurModal').hide();
        }
    } else $('#blurModal').hide();
}
